module.exports = __webpack_public_path__ + "img/pcc_logo_white.8729eda1.svg";